export type TTypeVoucherId = 1 | 2 | 3;

export interface VoucherType {
  id: TTypeVoucherId;
  name: string;
}

export const IdentifierTypeVoucher: VoucherType[] = [
  { id: 3, name: 'NOTA VENTA' },
  { id: 1, name: 'BOLETA' },
  { id: 2, name: 'FACTURA' }
];
